var map = {
	"./animal1.png": 323,
	"./animal10.png": 762,
	"./animal11.png": 763,
	"./animal12.png": 764,
	"./animal2.png": 324,
	"./animal3.png": 325,
	"./animal4.png": 765,
	"./animal5.png": 766,
	"./animal6.png": 767,
	"./animal7.png": 768,
	"./animal8.png": 769,
	"./animal9.png": 770
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 761;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animals ^\.\/animal.*\.png$
// module id = 761
// module chunks = 0